import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div>
      <div className="contact">
        <div className="container">
          <section className="section">
            <h2>Contact</h2>
            <div className="card">
              <p>Email: <b>swimwithasplash@gmail.com</b></p>
            </div>
          </section>
        </div>
      </div>
      <div className="get-involved">
        <div className="container">
          <section className="section">
            <h2>Get Involved</h2>
            <div className="card">
              <p>Interested in volunteering, partnering, or sponsoring with us? We welcome volunteers and community support to expand our impact.</p>
              <p>Contact us at <b>swimwithasplash@gmail.com</b> for more information or if you have any questions.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Contact;
